<template>
    <section class="my">
		<van-tabbar v-model="active" @change="changeTabbar" active-color="#4C535D" inactive-color="#4C535D">
			<van-tabbar-item>
				<span>抢单</span>
				<template #icon="props">
					<img :src="props.active ? orderAIcon : orderIcon" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>客户</span>
				<template #icon="props">
					<img :src="props.active ? customerAIcon : customerIcon" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item>
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ?myAIcon : myIcon" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
		<img src="../../assets/img/use_bg.png" class="bg">
        <div class="user">
            <div class="left" v-if="!token" @click="showloginModel">
                <img src="../../assets/img/user.png">
            </div> 
			 <div class="left" v-else>
                <img src="../../assets/img/user.png">
            </div> 

            <div class="right" v-if="!token">
                <p class="no_login" @click="showloginModel">点击登录/注册</p>
                <!-- <span>未认证</span> -->
            </div>
			<div v-else @click="skipFn(6)">
				<div class="right" v-if="user.authStatus == 20">
					<p class="name">{{user.phone}}</p>
					<img src="../../assets/img/approve.png" class="approveIcon">
				</div>
				<div class="right" v-else>
					<p class="name">{{user.phone}}</p>
					<div>
						<i>未认证</i>
						<p>
							去认证
							<img src="../../assets/img/arrow_r.png" >
						</p>
					</div>
				</div>
				
			</div>
			
        </div>
        <div class="kuaikebi">
            <img src="../../assets/img/kuaikebi_bg.png" class="kuaikebi_bg" />
			<i @click="skipFn(7)">去充值</i>
			<p class="user_ticket" @click="skipFn(8)">
				去使用
				<img src="../../assets/img/money_arrowr.png">
			</p>
			<div class="top">
				<p>
					<img src="../../assets/img/money_icon.png">
					展业币（个）</p>
				<h3>{{balance}}</h3>
			</div>
			<div class="bot">
				<img src="../../assets/img/ticket.png">
				<p>优惠券（张）</p>
				<h3>{{ticketCount}}</h3>
			</div>
        </div>
        <div class="list">
			<van-cell title="经理认证" :icon="jingliIcon" @click="skipFn(6)" >
                <template #right-icon>
                    <van-icon name="arrow" />
                </template>
            </van-cell>
            <van-cell title="交易记录" :icon="detailsIcon" @click="skipFn(1)" >
                <template #right-icon>
                    <van-icon name="arrow" />
                </template>
            </van-cell>
            <van-cell title="常见问题" :icon="questionIcon" @click="skipFn(2)">
                <template #right-icon>
                    <van-icon name="arrow" />
                </template>
            </van-cell>
            <van-cell title="查看协议" :icon="agreementIcon" @click="skipFn(3)">
                <template #right-icon>
                    <van-icon name="arrow" />
                </template>
            </van-cell>
            <van-cell title="客服咨询" :icon="kefuIcon" @click="skipFn(4)">
                <template #right-icon>
                    <van-icon name="arrow" />
                </template>
            </van-cell>
            <van-cell title="系统设置" :icon="settingIcon" @click="skipFn(5)">
                <template #right-icon>
                    <van-icon name="arrow" />
                </template>
            </van-cell>
        </div>
		<!-- <div class="ad_url" @click="skipTicket">
			<img :src="adUrl">
		</div> -->
        <div class="beian">
            <p>粤ICP备2021171216号-4A</p>
        </div>
    </section>
</template>

<script>
import jingliIcon from "assets/img/user_jingli.png";
import detailsIcon from "assets/img/user_details.png";
import questionIcon from "assets/img/user_question.png";
import agreementIcon from "assets/img/user_agreement.png";
import kefuIcon from "assets/img/user_kefu.png";
import settingIcon from "assets/img/user_setting.png";
import myServer from "api/my";
import ticketServer from "api/ticket";
import { Notify, Dialog } from 'vant';
import customerIcon from "assets/img/customer.png"
import customerAIcon from "assets/img/customer_a.png"
import orderIcon from "assets/img/order.png"
import orderAIcon from "assets/img/order_a.png"
import myIcon from "assets/img/my.png"
import myAIcon from "assets/img/my_a.png"


export default {
	name: 'user',
    components: {
    },
    data() {
        return {
			customerIcon,
			customerAIcon,
			customerAIcon,
			orderIcon,
			orderAIcon,
			myIcon,
			myAIcon,
			token: '',
			jingliIcon,
            detailsIcon,
            questionIcon,
            agreementIcon,
            kefuIcon,
            settingIcon,
            money: 0,
			isLoginModel: false,
			topLeftArrow: true,
			type:'login',
			active: 2,
			user: {
				name: '',
				phone: '',
				authStatus: '',
			},
			balance: 0,
			ticketCount: 0,
			adUrl: 'https://oss.kkqd.vip/baiboss/2022119/7yzk50w4r8/sd_user_ad_banner.png',
        };
    },	
	
    created() {
		this.token = localStorage.getItem('token')||''
		if(this.token) {
			this.getInfo()
		}
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
    methods: {
		getTicketCount() {
			let params = {
				pageNum: 1,
				pageSize: 100,
				history: 0,
			}
			ticketServer.SearchMyTicket(params).then((res) => {
				this.ticketCount = res.data.total
			})
		},
		 
		changeTabbar() {
			if(this.active == 0) {
				this.$router.push({ name: 'index'})
			}else if(this.active == 1) {
				this.$router.push({ name: 'clientele'})
			}
		},
		// 登录提示：抢单停止，改为推单模式
		showloginModel() {
			Dialog.confirm({
				title: '提示',
				message: '抢单模式已停止。现变更为推单模式。如需开通推送账户，请扫码添加客服开通。',
				confirmButtonText: '联系客服',
				cancelButtonText: '确认',
			}).then(() => {
				this.$router.push({ name: 'kefu' })
			}).catch(() => {
				// 点击"确认"，仅关闭弹窗，终止后续流程
			})
		},
		getInfo() {
			myServer.User().then((res) => {
				this.user.name = res.data.name
				this.user.phone = res.data.phone
				this.user.authStatus = res.data.authStatus
				localStorage.setItem("code", res.data.code)
				this.getWallet()
				this.getTicketCount()
			})
			
		},
		getWallet() {
			myServer.SearchWallet().then((res) => {
				this.balance = res.data.balance
			})
		},
		skipTicket() {
			this.$router.push({ name: 'ticket-get'})
		},


        skipFn(type) {
			if(type == 1 || type==5 || type == 6 || type==7) {
				if(!this.token) return this.showloginModel()
			}
            switch (type) {
                case 1:
					this.$router.push({ name: 'fulldetail'})
                    break;
                case 2:
					this.$router.push({ name: 'question'})
                    break;
                case 3:
					this.$router.push({ name: 'agreement'})
                    break;
                case 4:
					this.$router.push({ name: 'kefu'})
                    break;
                case 5:
					this.$router.push({ name: 'setting'})
                    break;
				case 6:
					this.$router.push({ name: 'attestation'})
                    break
				case 7:
					if(this.user.authStatus!=20) {
						Dialog.confirm({
							title: '提示',
							message: '请先完成身份认证',
						}).then(() => { 
							this.$router.push({ name: 'attestation'})
						})
					}else {
						this.$router.push({ name: 'full'})
					}
                    break
				case 8:
					this.$router.push({ name: 'ticket-index'})
                    break
                default:
                    break;
            }
        },
    },
};
</script>

<style lang="scss">
.my {
	padding-bottom: 30px;
	.ad_url {
		position: relative;
		z-index: 2;
		padding: 5px 29px;
		padding-bottom: 40px;
		background: #fff;
		img {
			width: 100%;
			border-radius: 4px;
		}
	}
    .beian {
		position: relative;
		z-index: 2;
        margin-top: 30px;
		p {
            text-align: center;
            font-size: 12px;
            color: #7d7d7d;
            line-height: 2;
        }
	}
	.van-tabbar--fixed {
			z-index: 99;
			height: 48px;
		}
		.van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after {
			display: none;
		}
		.van-tabbar-item__icon {
			margin-bottom: 0;
			img {
				height: 28px;
			}
		}
	.user {
		position: relative;
		z-index: 1;
		display: flex;
		align-items: center;
		padding: 25px 19px;
		padding-bottom: 8px;
		.left {
			img {
				width: 52px;
			}
		}
		.right {
			padding-left: 13px;
			.no_login {
				color: #161E2E;
				font-size: 16px;
			}
			span {
				display: block;
				padding-top: 5px;
				color: #575F72;
				font-size: 14px;
			}
			.name {
				color: #161E2E;
				font-size: 16px;
			}
			i,em,img {
				display: inline-block;
				font-style: normal;
			}
			i {
				font-size: 14px;
				color: #575F72;
				padding-right: 9px;
			}
			div	{
				margin-top: 5px;
				p {
					display: inline-block;
					width: 56px;
					height: 20px;
					line-height: 20px;
					border: 1Px solid #3A5EEC;
					text-align: center;
					color: #3A5EEC;
					border-radius: 18px;
					font-size: 11px;
					img {
						width: 5px;
					}
				}
			}
			.approveIcon {
				margin-top: 5px;
				width: 72px;
			}
		}
	}
	.kuaikebi {
		position: relative;
		z-index: 2;
		width: 100%;
		.kuaikebi_bg {
			width: 100%;
		}
		i {
			position: absolute;
			z-index: 3;
			top: 69px;
			right: 36px;
			background: linear-gradient(125deg, #FFF9C4 0%, #FFD9AB 63%, #FFC69B 100%);
			color: #2E68F7;
			font-size: 14px;
			width: 72px;
			height: 30px;
			line-height: 30px;
			border-radius: 20px;
			font-weight: bold;
			font-style: normal;
			text-align: center;
		}
		.user_ticket {
			position: absolute;
			top: 137px;
			right: 42px;
			display: flex;
			align-items: center;
			font-size: 13px;
			color: #fff;
			img {
				display: block;
				margin-left: 4px;
				width: 6px;
			}
		}
		.top {
			position: absolute;
			top: 30px;
			left: 43px;			
			p {
				display: flex;
				align-items: center;
				font-weight: lighter;
				font-size: 12px;
				color: #fff;
				img {
					display: block;
					width: 15px;
					margin-right: 3px;
				}
			}
			h3 {
				padding-top: 13px;
				font-size: 33px;
				font-weight: bold;
				color: #FFFFFF;
			}
		}
		.bot {
			position: absolute;
			top: 135px;
			left: 46px;
			display: flex;
			color: #fff;
			align-items: center;
			img {
				display: block;
				width: 17px;
				margin-right: 4px;
			}
			p {
				font-size: 13px;
				

			}
			h3 {
				font-size: 20px;
			}

		}


	}
	.bg {
		top: 0;
		left: 0;
		z-index: 1;
		position: absolute;
		width: 100%;
	}
    .list {
		position: relative;
		z-index: 2;
		margin-top: -46px;
        .van-cell {
            align-items: center;
            padding: 12px 29px;
			display: flex;
        }
        .van-cell__title {
            color: #393e4a;
            font-size: 15px;
        }
        .van-cell__left-icon {
			padding-top: 2px;
            img {
                width: 22px;
				height: 22px;
				
            }
        }
        .van-icon-arrow {
			color: #575F72;
			font-size: 16px;
        }

        .van-cell::after {
            display: none;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/index/User.vue